const getters = {
  enums: (state) => state['enums'].enums,
  locale: (state) => state['app'].locale,
  breadList: (state) => state['app'].breadList,
  userInfo: (state) => state['user'].userInfo,
};
export default getters;
